var _path, _path2, _path3, _rect, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReportingActive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33203 27.3815L15.5543 20.7148L22.7765 27.3815",
    stroke: "url(#paint0_linear_524_22831)",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2218 2.9375H2.77734V19.8264C2.77734 20.931 3.67277 21.8264 4.77734 21.8264H25.2218C26.3264 21.8264 27.2218 20.931 27.2218 19.8264V2.9375Z",
    fill: "url(#paint1_linear_524_22831)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66602 1.82617L28.3327 1.82617",
    stroke: "#D96700",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.11133,
    y: 6.27051,
    width: 17.7778,
    height: 12.2222,
    fill: "white",
    fillOpacity: 0.4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5547 15.1596L13.3699 12.4133L15.5861 14.5797L20.5547 9.604",
    stroke: "#FFFCF4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_524_22831",
    x1: 15.5543,
    y1: 20.7148,
    x2: 15.5543,
    y2: 27.3815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D06300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA350"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_524_22831",
    x1: 14.9996,
    y1: 2.9375,
    x2: 14.9996,
    y2: 21.8264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE7B32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDAA64"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportingActive);
export default "https://cdn.d2cgo.com/dtc_center/v19/ma_assets/static/media/reporting_active.e3647054bc75754456977a3cf0d8f68e.svg";
export { ForwardRef as ReactComponent };